import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis, LenisContext } from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

const ScrollReset = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

export default function App() {
    const lenis = useLenis();

    return (
        <LenisContext.Provider value={lenis}>
            <BrowserRouter>
                <ScrollReset />
                <div className="min-h-screen bg-paper font-sans text-slate-900">
                    <Nav />
                    <main>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/services" element={<ServicesPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="*" element={<HomePage />} />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                background: "#FFFFFF",
                                border: "1px solid #E2E8F0",
                                color: "#0F172A",
                            },
                        }}
                    />
                </div>
            </BrowserRouter>
        </LenisContext.Provider>
    );
}
